import {
  ActionIcon,
  Anchor,
  Box,
  Flex,
  AppShell,
  Drawer,
  Burger,
  VisuallyHidden,
} from "@mantine/core";
import SamblaLogo from "../../assets/sambla.svg";
import CloseIcon from "../../assets/close-icon.svg";
import { useDisclosure } from "@mantine/hooks";
import { Link, useLocation, useNavigate } from "@tanstack/react-router";
// import LanguageSelector from "../languageToggle/LanguageSelector";
import ExitOnboarding from "../exitOnboarding";
import { useUpdateCustomerData } from "../../hooks/ui";
import { useQueryClient } from "@tanstack/react-query";
import { usePOAStepsStore } from "../../hooks/ui/poaStepsDataStore";
import { useMediaQuery } from "@mantine/hooks";
import classes from "./index.module.css";

export function Header() {
  const [
    onboardingExitOpened,
    { open: openOnboardingExit, close: closeOnboardingExit },
  ] = useDisclosure(false);
  const [menuOpened, { close: closeMenu, toggle: toggleMenu }] =
    useDisclosure(false);
  const location = useLocation();
  const navigate = useNavigate();
  const isPOAAcquisition = location.pathname === "/signup";
  const { customerData, resetCustomerData } = useUpdateCustomerData();
  const queryClient = useQueryClient();
  const isMobile = useMediaQuery("(max-width: 56.25em)");
  const resetPOASteps = usePOAStepsStore((state) => state.resetToDefault);

  const logOutUser = () => {
    closeMenu();
    sessionStorage.clear();
    resetPOASteps();
    resetCustomerData();
    queryClient.cancelQueries();
    queryClient.clear();
    navigate({
      to: "/login",
      search: window.location.search
        ? Object.fromEntries(new URLSearchParams(window.location.search))
        : undefined,
    });
  };

  const getButtons = () => (
    <>
      <Anchor component={Link} to="/home" c="black" onClick={() => closeMenu()}>
        Hem
      </Anchor>
      <Anchor
        component={Link}
        to="/my-documents"
        c="black"
        onClick={() => closeMenu()}
      >
        Dokument
      </Anchor>
      <Anchor
        component={Link}
        to="/profile"
        c="black"
        onClick={() => closeMenu()}
      >
        Dina uppgifter
      </Anchor>

      <Anchor
        component="button"
        type="button"
        c="black"
        ta="left"
        onClick={logOutUser}
      >
        Logga ut
      </Anchor>
    </>
  );

  return (
    <>
      {isPOAAcquisition && (
        <ExitOnboarding
          opened={onboardingExitOpened}
          close={closeOnboardingExit}
        />
      )}
      <Drawer
        opened={menuOpened}
        onClose={closeMenu}
        title={<VisuallyHidden>Meny</VisuallyHidden>}
        closeButtonProps={{ "aria-label": "Stäng meny" }}
        classNames={{
          content: classes.menu,
          header: classes.menu,
          close: classes.menuClose,
        }}
      >
        <Flex
          component="nav"
          aria-label="Huvudmeny"
          direction={"column"}
          rowGap={"lg"}
        >
          <Box>
            <SamblaLogo aria-hidden="true" />
          </Box>
          {getButtons()}
        </Flex>
      </Drawer>
      <AppShell.Header
        bg="var(--wallet-color-neutrals-white)"
        withBorder={false}
      >
        <Flex justify="space-between" align="center" h="100%" px={"lg"}>
          <Box
            component={Link}
            to={
              customerData.credentials?.sessionToken
                ? "/home"
                : import.meta.env.VITE_LANDING_URL
            }
            aria-label="Sambla Pension - till startsidan"
          >
            <SamblaLogo aria-hidden="true" />
          </Box>
          <Flex align="center">
            {/* <LanguageSelector /> */}
            {isPOAAcquisition && (
              <ActionIcon
                variant="transparent"
                onClick={() => openOnboardingExit()}
                mr="1rem"
                aria-label="Stäng"
              >
                <CloseIcon />
              </ActionIcon>
            )}
            {customerData.credentials?.sessionToken && !isPOAAcquisition && (
              <>
                {isMobile && (
                  <Burger
                    opened={menuOpened}
                    onClick={toggleMenu}
                    aria-label={menuOpened ? "Stäng meny" : "Öppna meny"}
                    aria-expanded={menuOpened}
                    classNames={{ burger: classes.burger }}
                  />
                )}
                {!isMobile && (
                  <Flex
                    component="nav"
                    aria-label="Huvudmeny"
                    gap={"lg"}
                    align={"center"}
                  >
                    {getButtons()}
                  </Flex>
                )}
              </>
            )}
          </Flex>
        </Flex>
      </AppShell.Header>
    </>
  );
}
